import { useCallback } from 'react';

import useNavigation from '@zego/hooks/useNavigation';
import { useTracking } from '@zego/tracking';

import { urlStateFromApiState } from '../urlState';
import useCarEstimateResult from './useCarEstimateResult';

export default function useCarEstimateForm(
  estimateResultId,
  inputFn,
  eventName,
) {
  const { trackEvent } = useTracking();
  const { call } = useCarEstimateResult(estimateResultId);
  const navigation = useNavigation();

  const onSubmit = useCallback(
    (values, { onError, onSuccess } = {}) => {
      if (eventName) {
        trackEvent(eventName);
      }

      const data = {
        input: inputFn(values),
      };

      if (estimateResultId) {
        data.input.id = estimateResultId;
      }

      call({ variables: data }, (error, data) => {
        if (error) {
          /*
           * We only want to tell the form it's complete if something's gone
           * wrong, otherwise we get into a state where it looks like nothing is
           * happening while the next page is loading.
           */
          if (onError) onError();
        } else {
          const state = data.result.estimateResult.state;

          if (estimateResultId) {
            navigation.replace(
              {
                href: '/car/estimates/[state]/',
                as: `/car/estimates/${urlStateFromApiState(state)}/`,
              },
              {
                query: {
                  state: urlStateFromApiState(state),
                },
                shallow: true,
              },
            );
          } else {
            navigation.push(
              {
                href: '/car/estimates/[state]/',
                as: `/car/estimates/${urlStateFromApiState(state)}/`,
              },
              {
                query: {
                  state: urlStateFromApiState(state),
                },
              },
            );
          }
        }
        if (onSuccess) onSuccess();
      });
    },
    [call, estimateResultId, eventName, inputFn, navigation, trackEvent],
  );

  return onSubmit;
}
